module.exports = __webpack_public_path__ + "static/media/211-poland.31513ffc.svg";